"use strict";

var KeyEmitter = _interopRequireWildcard(require("makeup-key-emitter"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// REQUIRE
//const KeyEmitter = require('makeup-key-emitter');

// IMPORT

const widgetEl1 = document.getElementById("widget-1");
const widget2ButtonEls = document.querySelectorAll("#widget-2 button");
const events = ["arrowUpKey", "arrowDownKey", "arrowLeftKey", "arrowRightKey", "escapeKey", "spacebarKey", "enterKey", "homeKey", "endKey", "pageDownKey", "pageUpKey"];

// on widget1 container

KeyEmitter.add(widgetEl1);
events.forEach(function (eventName) {
  widgetEl1.addEventListener(`${eventName}Down`, function (e) {
    console.log(this, e);
  });
  widgetEl1.addEventListener(`${eventName}Up`, function (e) {
    console.log(this, e);
  });
});

// on widget2 buttons

[...widget2ButtonEls].forEach(function (el) {
  KeyEmitter.add(el);
  events.forEach(function (eventName) {
    el.addEventListener(`${eventName}Down`, function (e) {
      console.log(this, e);
    });
    el.addEventListener(`${eventName}Up`, function (e) {
      console.log(this, e);
    });
  });
});